// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"rich-text","577":"json-editor"}[chunkId] || chunkId) + "." + {"135":"a0c6f9e0","254":"dded13d1","577":"bfeaf10b","761":"aca9b6b0"}[chunkId] + ".chunk.js";
};